import { doc, writeBatch } from 'firebase/firestore'
import type { CategoryLinkWrite } from '@/features/inconsistencies/inconsistencies'
import { getDbOrThrow } from '@/lib/firebase'

/** Field names of a category reference per collection (materials vs rule documents). */
const FIELDS: Record<CategoryLinkWrite['collection'], { id: string; name: string }> = {
  materials: { id: 'categoryId', name: 'category' },
  ruleQuestions: { id: 'materialCategoryId', name: 'materialCategory' },
  ruleQuestionOptions: { id: 'materialCategoryId', name: 'materialCategory' },
}

const BATCH_LIMIT = 400

/**
 * Links documents to their category by id: sets the id field and refreshes the name copy, nothing
 * else (`update`, so a document deleted meanwhile fails instead of being recreated). Written in
 * batches of 400 — a batch is atomic, so a rejected document (e.g. a material the rules do not let
 * this admin edit) fails its whole chunk and the error is shown; the rows stay listed.
 */
export async function writeCategoryLinks(writes: CategoryLinkWrite[]): Promise<void> {
  const db = getDbOrThrow()
  for (let start = 0; start < writes.length; start += BATCH_LIMIT) {
    const batch = writeBatch(db)
    for (const write of writes.slice(start, start + BATCH_LIMIT)) {
      const fields = FIELDS[write.collection]
      batch.update(doc(db, write.collection, write.docId), {
        [fields.id]: write.categoryId,
        [fields.name]: write.categoryName,
      })
    }
    await batch.commit()
  }
}
